var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkwayAim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u7EC4_1",
    "data-name": "\\u7EC4 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipCircle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32
  })), /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3284F7;\n        stroke: #000;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.9;\n      }\n\n      .cls-3 {\n        fill: #ffea00;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_1",
    "data-name": "\\u692D\\u5706 1",
    className: "cls-1",
    cx: 32,
    cy: 32,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#clipCircle)",
    id: "\\u77E9\\u5F62_1_\\u62F7\\u8D1D_11",
    "data-name": "\\u77E9\\u5F62 1 \\u62F7\\u8D1D 11",
    className: "cls-2",
    d: "M-31.992,34.47h5.975l-34.834,96.386H-70.46Zm11.083-.393h5.96L-42.938,129.84h-9.571Zm10.7,0.852h5.992l-21.67,97.114h-9.654Zm11.061-.4H6.834l-14.86,96.485h-9.615Zm11.006-.394h5.962L9.688,130H0.111Zm10.885,0.852h5.994l-1.531,97.216h-9.66Zm10.983-.4H39.71l5.156,96.585H35.245ZM44.66,34.2h5.964l11.757,95.96H52.8Zm10.9-.229h5.956l18.321,95.6H70.276Zm11.072,0.685h5.982l25.213,96.684H88.2Zm10.851-.394h5.967l31.69,96.058h-9.588Zm10.856-.229H94.3l38.187,95.7h-9.567Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u9EC4",
    className: "cls-3",
    d: "M38.9,22.967L35.136,22l4.088,9.822L42.882,44.77l4.627,9.174-3.551,1.943-5.165-9.174L33.844,37l-5.525,7.028L27.7,56.4l-3.824.124L23.839,41.64l5.272-8.2-1.937-8.2-3.694,2.672-7.6,2.833-1.385-2.894,8.3-4.233,2.766-5.825,1.721-1.835,3.12-.972,3.766,0.54,8.286,4.834,2.58,8.981-3.12,1.187ZM26.984,14.7a3.612,3.612,0,1,1,3.6-3.612A3.606,3.606,0,0,1,26.984,14.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkwayAim);
export default __webpack_public_path__ + "static/media/walkway-aim.2b989cd0fc933d77b16b379c02a094f6.svg";
export { ForwardRef as ReactComponent };